import type { IconData } from '@stacksjs/iconify-core'

export const coffeeCup: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4a6 6 0 1 0 12 0V2H2zm14-4h1a3 3 0 0 1 0 6h-1.252A8 8 0 0 1 0 4V0zm0 4h1a1 1 0 0 0 0-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default coffeeCup
